import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-dark text-white py-10">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-start mb-10 gap-8">
          <div className="md:w-1/3">
            <div className="mb-6">
              <a href="#" className="flex items-center">
                <img src="/image/logo.png" alt="GenAI Dev" className="h-10" />
              </a>
            </div>
            <p className="text-gray-400 mb-6 max-w-sm">
              Generative AI 기술을 통해 챗봇에서부터 실생활의 모든 것들까지 파고들어 AI 혁신을 일궈내는 기업입니다.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-primary transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-primary transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/>
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-primary transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                </svg>
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-bold mb-4">바로가기</h3>
            <ul className="space-y-2">
              <li>
                <a href="#about" className="text-gray-400 hover:text-primary transition-colors">회사 소개</a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-primary transition-colors">서비스</a>
              </li>
              <li>
                <a href="#team" className="text-gray-400 hover:text-primary transition-colors">팀</a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-primary transition-colors">문의하기</a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-bold mb-4">서비스</h3>
            <ul className="space-y-2">
              <li>
                <a href="#services" className="text-gray-400 hover:text-primary transition-colors">챗봇 개발</a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-primary transition-colors">AI 솔루션 통합</a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-primary transition-colors">AI 전략 컨설팅</a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-primary transition-colors">AI 콘텐츠 생성</a>
              </li>
              <li>
                <a href="#subscription" className="text-gray-400 hover:text-primary transition-colors">구독 서비스</a>
              </li>
              <li>
                <a href="#education" className="text-gray-400 hover:text-primary transition-colors">AI 교육</a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-bold mb-4">연락처</h3>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>서울특별시 서초구 사임당로8길 13, 4층 402-L83호 (서초동)</li>
              <li>이메일: info@genaidev.io</li>
              <li>전화: 010-8931-6824</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-6 mb-6">
          <h3 className="text-sm font-bold mb-3 text-gray-300">사업자정보</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-1 text-xs text-gray-400">
            <p><span className="text-gray-500">상호:</span> 에이아이 데브 스튜디오 (AI DEV STUDIO)</p>
            <p><span className="text-gray-500">대표:</span> 천재호</p>
            <p><span className="text-gray-500">사업자등록번호:</span> 765-14-01312</p>
            <p><span className="text-gray-500">통신판매업 신고번호:</span> 준비중</p>
            <p className="sm:col-span-2"><span className="text-gray-500">사업장 주소:</span> 서울특별시 서초구 사임당로8길 13, 4층 402-L83호 (서초동)</p>
            <p><span className="text-gray-500">대표 전화:</span> 010-8931-6824</p>
            <p><span className="text-gray-500">이메일:</span> info@genaidev.io</p>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            &copy; {new Date().getFullYear()} GenAI Dev. All rights reserved.
          </p>
          <div className="flex space-x-6 text-sm">
            <a href="/privacy-policy.html" className="text-gray-500 hover:text-primary transition-colors">개인정보처리방침</a>
            <a href="/terms.html" className="text-gray-500 hover:text-primary transition-colors">이용약관</a>
            <a href="/refund-policy.html" className="text-gray-500 hover:text-primary transition-colors">환불정책</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 